// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"b454c1f4","59":"25baa197","457":"e1ef2ec2","561":"ef0d4664","674":"9f33e220","965":"292aff79","989":"6320ec4e"}[chunkId] + ".chunk.js";
};